// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/fuelling-safety.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/fuelling-safety/fuelling-safety.js';
import g1 from '../lessons/aeronautics/fuelling-safety/jet-fuel-static-charge.js';

mount([g0, g1]);
